module.exports = __webpack_public_path__ + "img/building.a20fb27f.svg";